module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group esma_form_group"
  }, [(_vm.showLabel) ? _c('label', {
    class: {
      'col-xs-4': true, 'control-label': true, 'esma_form_label': true, 'esma_error_field': _vm.showAsError
    },
    attrs: {
      "for": _vm.fieldID
    }
  }, [_vm._v(_vm._s(_vm.fieldLabel) + "  "), (_vm.isRequired) ? _c('span', {
    staticClass: "is_required",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("＊")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    class: _vm.fieldClass,
    staticStyle: {
      "padding": "1px 0px 1px 7px"
    }
  }, [_c('datepicker', {
    attrs: {
      "disabled-picker": _vm.isDisabled,
      "input-style": _vm.disabledStyle + ';height: 24px!important;' + _vm.filedStyle,
      "input-button-style": _vm.buttonStyle,
      "input-class": " form-control force-white",
      "id": _vm.fieldID,
      "name": _vm.fieldID,
      "value": _vm.fieldValue,
      "controller": _vm.dp_controller,
      "placeholder": "",
      "calendar-style": "left:-100px;"
    },
    on: {
      "input": _vm.updateValue
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ac832d7c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/fields/date-box.vue
// module id = 1051
// module chunks = 0